import React from 'react';
import { Link } from 'react-router-dom';

// One row of legal links, used in every page footer.
const LegalLinks = ({ className = '', linkClass = 'hover:text-indigo-600 hover:underline' }) => (
  <nav className={`flex flex-wrap justify-center gap-x-5 gap-y-1 text-sm text-gray-600 ${className}`} aria-label="Legal">
    <Link to="/terms" className={linkClass}>Terms &amp; Conditions</Link>
    <Link to="/privacy" className={linkClass}>Privacy Policy</Link>
    <Link to="/refund" className={linkClass}>Refund Policy</Link>
    <Link to="/shipping" className={linkClass}>Delivery Policy</Link>
    <Link to="/contact" className={linkClass}>Contact Us</Link>
  </nav>
);

export default LegalLinks;
